import { render, staticRenderFns } from "./ResearchProfileView.vue?vue&type=template&id=d462108c&scoped=true&"
import script from "./ResearchProfileView.vue?vue&type=script&lang=js&"
export * from "./ResearchProfileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d462108c",
  null
  
)

export default component.exports